const EventButton = ({ className, imgSrc, icon, buttonText }) => {
    return (
        <button className={`${className} mt-[12px] h-[40px] mb-[8px] justify-center flex items-center rounded-[999px] gap-[4px] w-full px-[16px] py-[12px]`}>
            {
                imgSrc &&
                <>
                    <img
                        src={imgSrc}
                        className="w-[60px] object-contain h-[20px]"
                        alt="group users avatar"
                    />
                    {buttonText}
                </>
            }

            {
                icon &&
                <>
                    {icon}
                    {buttonText}
                </>
            }
        </button>
    )
}

export default EventButton